// Make sure we set ignoreUsage to true when archiving an application
const applicationMiddleware = (db)=>{
    db.$use(async (params, next)=>{
        if (params.model === "Application" && [
            "create",
            "update"
        ].includes(params.action)) {
            if (params.args && params.args.data && params.args.data.archivedAt) {
                params.args.data.ignoreUsage = true;
            }
        }
        const result = await next(params);
        return result;
    });
};
export default applicationMiddleware;
